import ApiClient from './ApiClient';

export interface AchievementConfirm {
  orgName: string,
  orgCode: string,
  closingDate: string,
  dateFrom: string,
  dateTo: string,
  confirmStatus: string,
  unConfirmFlag: string,
  ownCnt: string,
}

export const getList = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const response = await ApiClient.get(`/v1/achievementConfirm/${companyCode}`, {}, params);
  return response.data;
};


export const searchDate = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const query = {
    ...params,
    closeDateFlg: false,
    targetDate: '',
  };

  const response = await ApiClient.get(`/v1/employments/searchDate/${companyCode}`, {}, query);
  return response.data;
};

export const getListClosingDate = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const query = {
    ...params,
  };

  const response = await ApiClient.get(`/v1/employments/selectListClosingDate/${companyCode}`, {}, query);
  return response.data;
};

export const getListEmployment = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const query = {
    ...params,
  };

  const response = await ApiClient.get(`/v1/employments/selectListRangeAndClosingDate/${companyCode}`, {}, query);
  return response.data;
};

export const getEmployment = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const query = {
    ...params,
  };

  const response = await ApiClient.get(`/v1/employments/applied/all/${companyCode}`, {}, query);
  return response.data;
};


export const getOrganizationsTrees = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const query = {
    ...params,
  };

  const response = await ApiClient.get(`/v2/organizations/trees/${companyCode}`, {}, query);
  return response.data;
};


export const getListStaff = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const query = {
    ...params,
  };

  const response = await ApiClient.get(`/v1/staffs/list/${companyCode}`, {}, query);
  return response.data;
};

export const getListStaffSelectBox = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const query = {
    ...params,
  };

  const response = await ApiClient.get(`/v2/staffs/list/selectbox/${companyCode}`, {}, query);
  return response.data;
};


export const getStamplist = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const query = {
    ...params,
  };

  const response = await ApiClient.get(`/v1/stamplist/list/${companyCode}`, {}, query);
  return response.data;
};


export const getHolidayUsingStatus = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const currentStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const currentOrgCode = sessionStorage.getItem('loginUser.orgCode') || '';
  const query = {
    ...params,
    currentStaffCode,
    currentOrgCode
  };

  const response = await ApiClient.get(`/v1/stamplist/holiday/usingstatus/${companyCode}`, {}, query);
  return response.data;
};

export const getStampSubTotal = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const query = {
    ...params,
  };

  const response = await ApiClient.get(`/v1/stamplist/subtotal/${companyCode}`, {}, query);
  return response.data;
};

export const getListOutputLayout = async (): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const response = await ApiClient.get(`/v1/outputlayouts/${companyCode}`, {}, {});
  return response.data;
};

export const achievementConfirm = async (params: any, url: string): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const query = {
    ...params,
  };

  const reponse = await ApiClient.post(`/v1/achievementConfirm/${url}/${companyCode}`, {}, query);
  return reponse.data;
};

export const achievementConfirmStamp = async (params: any, url: string): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const query = {
    ...params,
  };

  const reponse = await ApiClient.post(`/v1/achievementConfirmStamp/${url}/${companyCode}`, {}, query);
  return reponse.data;
};

export const postCopyAchievement = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const query = {
    ...params,
  };

  const reponse = await ApiClient.post(`/v2/stamplist/copyAchievement/${companyCode}`, {}, query);
  return reponse.data;
};

export const getCsvOutput = async (params: any, fileName: string): Promise<void> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const query = {
    ...params,
  };

  await ApiClient.downloadCsvNoConvert(`/v1/achievementConfirm/csvOutput/${companyCode}`, query, fileName);
};

export const getTimeList = async (params: any): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const query = {
    ...params,
  };

  const reponse = await ApiClient.get(`/v1/achievementConfirm/timeDayList/${companyCode}`, {}, query);
  return reponse.data;
};
